<template>
  <div>
    <!-- <ul class="button-styles flex">
      <li
        class="button-style-item"
        @click="changeButtonStyle(style, index)"
        :class="activeIndex === index ? 'active' : ''"
        v-for="(style, index) in showStyles"
        :key="index"
      >
        <div class="img-style-box">       
          <i class="icon-checked" v-if="request_prefix !== 'bigScreen'"></i>
          <el-button class="button-item" :style="computedStyle(style)">按钮</el-button>
        </div>
        <p>样式{{index+1}}</p>
      </li>
    </ul>
    <el-collapse class="expand-el-collapse" v-model="activeNames" v-if="moreStyles.length > 0">
      <el-collapse-item :title="activeNames.length > 0 ? '收起' : '展开'" name="1">
        <ul class="button-styles flex">
          <li
            class="button-style-item"
            @click="changeButtonStyle(style, index + showLen)"
            :class="activeIndex === index + showLen ? 'active' : ''"
            v-for="(style, index) in moreStyles"
            :key="index + showLen"
          >
            <el-button class="button-item" :style="computedStyle(style)">按钮</el-button>
          </li>
        </ul>
      </el-collapse-item>
    </el-collapse> -->
    <local-style
      class="template-styles"
      :options="options"
      :container_id="ids.container_id"
      :rect_id="ids.rect_id"
      :elementType="elementType"
      :styleImgs="isIp?ipStyleImgs:styleImgs"
      ref="localStyleComponent"
    />
  </div>
</template>

<script>
import localStyle from "toolbarComponents/styles/local-style.vue"
export default {
  name: "button-options-style",
  components: { localStyle },
  props: {
    options: Object
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    buttonStyles() {
      let menu =
        this.request_prefix === "bigScreen" ? this.$store.state.bigScreenMenu.menu : this.$store.state.menu.menu
      let styles = [],
        stylesOption = []
      for (let i = 0; i < menu.children.length; i++) {
        if (menu.children[i].type !== "element" && menu.children[i].type !== "baseElement") {
          continue
        }
        for (let j = 0; j < menu.children[i].children.length; j++) {
          if (menu.children[i].children[j].type === "cxButton") {
            styles = menu.children[i].children[j].children
            break
          }
        }
      }
      styles.forEach(item => {
        stylesOption.push(item.attribute.options)
      })
      return stylesOption
    },
    showStyles() {
      return this.buttonStyles.length > this.showLen ? this.buttonStyles.slice(0, this.showLen) : this.buttonStyles
    },
    moreStyles() {
      return this.buttonStyles.length > this.showLen ? this.buttonStyles.slice(this.showLen) : []
    },
    isIp(){
      return this.options.pluginName?.includes("getIpPlugin") || false
    },
    elementType(){
      // IP是基于按钮写的,此处进行区分便于获取menu对应的分类
      if(this.isIp){
        return "cxIP"
      }
      return "cxButton"
    }
  },
  data() {
    return {
      activeIndex: undefined,
      activeNames: [],
      showLen: 6,
      styleImgs: [require("assets/images/leftMenu/button/style1.png")],
      ipStyleImgs: [require("assets/images/leftMenu/IP/style1.png")]
    }
  },
  methods: {
    changeButtonStyle(style, index) {
      this.activeIndex = index
      let tmpData = JSON.parse(JSON.stringify(style))
      let curOptions = this.$getOptions()
      tmpData.left = curOptions.left
      tmpData.top = curOptions.top
      tmpData.width = curOptions.width
      tmpData.height = curOptions.height
      let data = {
        ...this.ids,
        options: tmpData
      }
      this.$store.dispatch(this.request_prefix + "/changeAllOptions", data)
    },
    computedStyle(style) {
      return {
        lineHeight: `${style.height}px`,
        // width: `${style.width}px`,
        fontSize: `${style.fontSize}px`,
        borderRadius: `${style.borderTopLeftRadius}px ${style.borderTopRightRadius}px ${style.borderBottomRightRadius}px  ${style.borderBottomLeftRadius}px`,
        backgroundColor: style.bgColor,
        color: style.color,
        border: `${style.borderWidth}px ${style.borderStyle} ${style.borderColor}`,
        boxShadow: `${style.boxShadowH}px ${style.boxShadowV}px  ${style.boxShadowBlur}px  ${style.boxShadowSpread}px ${style.boxShadowColor}`
      }
    },
    showAllStyles() {
      this.$refs.localStyleComponent.showAllStyles()
    }
  }
}
</script>

<style lang="scss" scoped>
.button-styles {
  justify-content: space-between;
  flex-wrap: wrap;
  .button-style-item {
    // min-width: 33%;
    width: calc((100% - 16px) / 3);
    margin: 0 4px 12px;
    box-sizing: border-box;
    border-radius: 4px;
    // border: 1px solid #e9e9e9;
    text-align: center;
    &:nth-child(3n + 1) {
      margin-left: 0;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.active {
      .img-style-box {
        border: 1px solid var(--themeColor);
        box-shadow: 0 0 0 1px var(--themeColor);
        .icon-checked {
          display: block;
        }
      }
    }
    .img-style-box {
      position: relative;
      height: 53px;
      line-height: 53px;
      border-radius: 4px;
      margin-bottom: 8px;
      background-color: var(--styleBgColor);
      border: 1px solid var(--styleBgColor);
      .icon-checked {
        position: absolute;
        right: 0;
        top: 0;
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/images/icon-checked.png);
        background-size: 100% 100%;
        display: none;
      }
    }
  }
  .button-item {
    width: 100%;
    border: none;
    padding: 0;
  }
}
</style>
